import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuard } from './auth.guard';
import { StartupService } from '../service/startup.service';

@Injectable({
  providedIn: 'root',
})
export class StartupGuard {
  constructor(
    private readonly startupService: StartupService,
    private readonly authGuard: AuthGuard
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // first calling the AuthGuard and continuing to load the application only if the authentication was successful.
    return this.authGuard.canActivate(next, state).then(isAuthenticated => {
      if (!isAuthenticated) {
        return isAuthenticated;
      }
      return this.startupService.start();
    });
  }
}
